import { createStore, createEvent } from "effector";
import { PAGES, TotemVacuumStoreState } from "./VacumStore.types";
import { vacuumStoreInteraction, vacuumStoreState } from "./VacumStore.consts";
import { fetchVacuumCleanersEffect } from "./VacuumStore.effects";
import { PaymentOption, VACUUM_STATUS, VacuumOption } from "../../types/vacuum.types";

// Eventos (ações)
export const setPage = createEvent<PAGES>('setPage');
export const setSelectedVacuum = createEvent<VacuumOption>('setSelectedVacuum');
export const setSelectedMinutes = createEvent<number>('setSelectedMinutes');
export const setSelectedPayment = createEvent<PaymentOption>('setSelectedPayment');
export const setFinalPrice = createEvent<number>('setFinalPrice');
export const setTotemId = createEvent<string>('setTotemId');
export const setTerminalId = createEvent<string>('setTerminalId');
export const setPaymentId = createEvent<string>('setPaymentId');
export const setCieloTransactionId = createEvent<string>('setCieloTransactionId');
export const setErrorMsg = createEvent<string>('setErrorMsg');
export const setTaxId = createEvent<string>('setTaxId');
export const restartInteraction = createEvent('restartInteraction');
export const resetVacuumStore = createEvent();

// Store inicial
export const VacuumStore = createStore<TotemVacuumStoreState>(vacuumStoreState)
  .on(setPage, (store, page) => ({
    ...store,
    currPage: page
  }))
  .on(setSelectedVacuum, (store, selectedVacuum) => ({
    ...store,
    selectedVacuum
  }))
  .on(setSelectedMinutes, (store, selectedMinutes) => ({
    ...store,
    selectedMinutes
  }))
  .on(setSelectedPayment, (store, selectedPayment) => ({
    ...store,
    selectedPayment
  }))
  .on(setFinalPrice, (store, finalPrice) => ({
    ...store,
    finalPrice
  }))
  .on(setTaxId, (store, taxId) => ({
    ...store,
    taxId
  }))
  .on(setTotemId, (store, totemId) => ({
    ...store,
    totemId
  }))
  .on(setTerminalId, (store, terminalId) => ({
    ...store,
    terminalId
  }))
  .on(setPaymentId, (store, paymentId) => ({
    ...store,
    paymentId
  }))
  .on(setCieloTransactionId, (store, cieloTransactionId) => ({
    ...store,
    cieloTransactionId
  }))
  .on(setErrorMsg, (store, errorMsg) => ({
    ...store,
    errorMsg
  }))
  .on(fetchVacuumCleanersEffect.doneData, (store, vacuumOptions) => {
    
    const availableVacuums = vacuumOptions?.filter(vac => vac.status === VACUUM_STATUS.DESLIGADO);


    if(!availableVacuums.length) {
      availableVacuums.push({} as VacuumOption)
    }

    return ({
    ...store,
    vacuumOptions,
    selectedVacuum: availableVacuums[0]
  })})
  .on(restartInteraction, (store) => ({
    ...store,
    ...vacuumStoreInteraction
  }))
  .reset(resetVacuumStore);
